import { render, staticRenderFns } from "./ImportXmlComponent.vue?vue&type=template&id=672ef77e&scoped=true&"
import script from "./ImportXmlComponent.vue?vue&type=script&lang=js&"
export * from "./ImportXmlComponent.vue?vue&type=script&lang=js&"
import style0 from "./ImportXmlComponent.vue?vue&type=style&index=0&id=672ef77e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "672ef77e",
  null
  
)

export default component.exports